import axios from 'utils/axios';
import type {
    ComingDataItem,
    SupplierRequestActionResultType,
    SupplierRequestComingResultType,
    SupplierRequestComingTransferPayloadType,
    SupplierRequestComingTransferResultType,
    SupplierRequestCreateDataType,
    SupplierRequestCreateResultType,
    SupplierRequestFullType,
    SupplierRequestListParamsType,
    SupplierRequestListResultType,
    SupplierRequestSendEmailPayloadType,
} from '@econtractor/types';

export const getList = async (
    params: SupplierRequestListParamsType = {},
): Promise<SupplierRequestListResultType | null> => {
    try {
        const response = await axios('/warehouses/supplier-requests', { params });
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const getById = async (
    requestId: number | string,
): Promise<SupplierRequestFullType | null> => {
    try {
        const response = await axios(`/warehouses/supplier-requests/${requestId}`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const create = async (
    data: SupplierRequestCreateDataType,
): Promise<SupplierRequestCreateResultType | null> => {
    try {
        const response = await axios.post('/warehouses/supplier-requests', data);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const markDone = async (
    requestId: number | string,
): Promise<SupplierRequestActionResultType | null> => {
    try {
        const response = await axios.patch(`/warehouses/supplier-requests/${requestId}/done`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const markDeleted = async (
    requestId: number | string,
): Promise<SupplierRequestActionResultType | null> => {
    try {
        const response = await axios.patch(`/warehouses/supplier-requests/${requestId}/delete`);
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const createComing = async (
    requestId: number | string,
    items: ComingDataItem[],
): Promise<SupplierRequestComingResultType | null> => {
    try {
        const response = await axios.post(
            `/warehouses/supplier-requests/${requestId}/coming`,
            items,
        );
        return response?.data || null;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const transferComing = async (
    requestId: number | string,
    comingId: number | string,
    payload: SupplierRequestComingTransferPayloadType,
): Promise<SupplierRequestComingTransferResultType | null> => {
    try {
        const response = await axios.post(
            `/warehouses/supplier-requests/${requestId}/comings/${comingId}/transfer`,
            payload,
        );
        return response?.data || null;
    } catch (e: unknown) {
        console.error(e);
        if (e && typeof e === 'object' && 'stat' in e) {
            return e as SupplierRequestComingTransferResultType;
        }
        return null;
    }
};

export const sendEmail = async (
    requestId: number | string,
    payload: SupplierRequestSendEmailPayloadType,
): Promise<boolean> => {
    try {
        const response = await axios.post(
            `/warehouses/supplier-requests/${requestId}/send-email`,
            payload,
        );
        return Boolean(response?.data?.stat);
    } catch (e) {
        console.error(e);
        return false;
    }
};
